// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"0eb08282","703":"2bd63b61","787":"524b86e2"}[chunkId] + ".chunk.js";
};